import { Schema } from "effect";
import { AccountId } from "../../ids/definitions";

/** A public API token acting for its account. */
export const SystemApiTokenActor = Schema.Struct({
  kind: Schema.Literal("API_TOKEN"),
  tokenId: Schema.BigInt,
});
export type SystemApiTokenActor = typeof SystemApiTokenActor.Type;

export const SystemActor = SystemApiTokenActor;
export type SystemActor = typeof SystemActor.Type;

/** The caller sets `accountId` from its own verified credential, never from its caller's input. */
export const SystemRequestContext = {
  accountId: AccountId,
  actor: SystemActor,
};
